// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__1AVr-","open":"MenuToggle_open__EAf9L"};